<div class="preloader" *ngIf="isSpinnerVisible">
  <e11-loader-dots [size]="'md'" [color]="'e11-bg-skin-primary-accent'"></e11-loader-dots>
</div>
